module.exports = __webpack_public_path__ + "img/tc-kjzf.2b42c44e.png";